import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminLoginComponent } from './admin-login/admin-login.component';
import { LoginComponent } from './login/login.component';
import { NotAuthenticatedGuard } from './guards/not-authenticated.guard';
import { AlwaysAuthenticatedGuard } from './guards/always-authenticated.guard';
import { AdminGuard } from './guards/admin.guard';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { UserHomeComponent } from './user-home/user-home.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ActivateUserComponent } from './activate-user/activate-user.component';
import { CompanyDetailsComponent } from './company-details/company-details.component';
import { UserDetailsComponent } from './user-details/user-details.component';
import { RegisterUserComponent } from './register-user/register-user.component';
import { OrderComponent } from './order/order.component';
import { EditCompanyComponent } from './edit-company/edit-company.component';
import { SelectBusinessComponent } from './select-business/select-business.component';
import { OpeningsComponent } from './openings/openings.component';
import { AddOpeningComponent } from './add-opening/add-opening.component';
import { AddSubgroupComponent } from './add-subgroup/add-subgroup.component';
import { SingleOpeningComponent } from './single-opening/single-opening.component';
import { ProfileOpenedComponent } from './profile-opened/profile-opened.component';
import { HeadhuntingComponent } from './headhunting/headhunting.component';
import { CompanyBillingComponent } from './company-billing/company-billing.component';
import { MarketpalceComponent } from './marketpalce/marketpalce.component';
import { SingleMarketplaceComponent } from './single-marketplace/single-marketplace.component';
import { WishlistsComponent } from './wishlists/wishlists.component';
import { SingleWishlistComponent } from './single-wishlist/single-wishlist.component';
import { MessagesComponent } from './messages/messages.component';
import { AdminCompaniesComponent } from './admin-companies/admin-companies.component';
import { AdminAddCompanyComponent } from './admin-add-company/admin-add-company.component';
import { AdminCompanyBillingComponent } from './admin-company-billing/admin-company-billing.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { AdminUserDetailsComponent } from './admin-user-details/admin-user-details.component';
import { AdminCompanyDetailsComponent } from './admin-company-details/admin-company-details.component';
import { AdminCompanyPricingComponent } from './admin-company-pricing/admin-company-pricing.component';
import { AdminOpeningsComponent } from './admin-openings/admin-openings.component';
import { AdminParamsComponent } from './admin-params/admin-params.component';
import { AdminSingleParamComponent } from './admin-single-param/admin-single-param.component';
import { AdminOpeningDetailsComponent } from './admin-opening-details/admin-opening-details.component';
import { MessageComponent } from './message/message.component';
import { AddMarketplaceComponent } from './add-marketplace/add-marketplace.component';
import { ValidateMobileUserComponent } from './validate-mobile-user/validate-mobile-user.component';
import { ForumComponent } from './forum/forum.component';
import { ForumSingleTopicComponent } from './forum-single-topic/forum-single-topic.component';
import { PubOpeningsComponent } from './pub-openings/pub-openings.component';
import { PubOpeningComponent } from './pub-opening/pub-opening.component';
import { AdminCooperationCodesComponent } from './admin-cooperation-codes/admin-cooperation-codes.component';
import { AdminTranslationsComponent } from './admin-translations/admin-translations.component';
import { AdminConsumerProductsComponent } from './admin-consumer-products/admin-consumer-products.component';
import { CompanyRegisterComponent } from './company-register/company-register.component';
import { AdminValidateCompanyComponent } from './admin-validate-company/admin-validate-company.component';
import { CompanyInterestsComponent } from './company-interests/company-interests.component';
import { AdminArticlesComponent } from './admin-articles/admin-articles.component';
import { AdminJobtitlesComponent } from './admin-jobtitles/admin-jobtitles.component';
import { AdminSkillsComponent } from './admin-skills/admin-skills.component';
import { AdminSchoolsComponent } from './admin-schools/admin-schools.component';
import { EmployerListsComponent } from './employer-lists/employer-lists.component';
import { SingleEmployerListComponent } from './single-employer-list/single-employer-list.component';
import { SearchAlertsComponent } from './search-alerts/search-alerts.component';
import { SingleSearchAlertComponent } from './single-search-alert/single-search-alert.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'register-business',
    component: CompanyRegisterComponent,
  },
  {
    path: 'select-business',
    component: SelectBusinessComponent,

  },
  {
    path: 'activate-mobile-user/:token',
    component: ValidateMobileUserComponent,
  },
  {
    path: ':businessID/company-profile',
    component: PubOpeningsComponent,
  },
  {
    path: ':businessID/job-announcements',
    component: PubOpeningComponent,
  },
  {
    path: 'admin-login',
    component: AdminLoginComponent,
    canActivate: [NotAuthenticatedGuard]
  },
  {
    path: 'admin/dashboard',
    component: AdminDashboardComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/cooperation-codes',
    component: AdminCooperationCodesComponent,
    canActivate: [AdminGuard]
  },
  {
    path: ':businessID/users/home',
    component: UserHomeComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/reset-password/:id',
    component: ResetPasswordComponent,
    canActivate: [NotAuthenticatedGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [NotAuthenticatedGuard]
  },
  {
    path: ':businessID/activate-user/:token',
    component: ActivateUserComponent,
    canActivate: [NotAuthenticatedGuard]
  },
  {
    path: 'activate-user/:token',
    component: ActivateUserComponent,
    canActivate: [NotAuthenticatedGuard]
  },
  {
    path: ':businessID/forum',
    component: ForumComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/forum/topic/:id',
    component: ForumSingleTopicComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/company-details',
    component: CompanyDetailsComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/user-details/:id',
    component: RegisterUserComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/register-user',
    component: RegisterUserComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/edit-business',
    component: EditCompanyComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/order',
    component: OrderComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/company-billing',
    component: CompanyBillingComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/business-interests',
    component: CompanyInterestsComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/headhunting',
    component: HeadhuntingComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/marketplace',
    component: MarketpalceComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  //my company
  {
    path: ':businessID/marketplaces/marketplace/:id',
    component: MarketpalceComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  //Other company
  {
    path: ':businessID/marketplaces/marketplace',
    component: MarketpalceComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/marketplaces/marketplace/single-marketplace/:type/:marketplaceID',
    component: SingleMarketplaceComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/wishlists',
    component: WishlistsComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/wishlists/single-wishlist/:wishlistID',
    component: SingleWishlistComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/messages',
    component: MessagesComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/messages/message/:id',
    component: MessageComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/openings/:type',
    component: OpeningsComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: 'admins/admin/openings/opening-details/:id',
    component: AdminOpeningDetailsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: ':businessID/marketplaces/add-marketplace',
    component: AddMarketplaceComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/marketplaces/edit-marketplace/:marketplaceID',
    component: AddMarketplaceComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/openings/add-opening/:type',
    component: AddOpeningComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/openings/edit-opening/:type/:id',
    component: AddOpeningComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/openings/single-opening/:openingID',
    component: SingleOpeningComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/openings/profile-opened/:type/:openingID/:userID',
    component: ProfileOpenedComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/wishlist/profile-opened/:type/:openingID/:userID',
    component: ProfileOpenedComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/subgroups/add-subgroup',
    component: AddSubgroupComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/subgroups/edit-subgroup/:id',
    component: AddSubgroupComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/lists',
    component: EmployerListsComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/search-alerts',
    component: SearchAlertsComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/search-alerts/search-alert/:id',
    component: SingleSearchAlertComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: ':businessID/lists/list/:id',
    component: SingleEmployerListComponent,
    canActivate: [AlwaysAuthenticatedGuard]
  },
  {
    path: 'admins/admin/companies',
    component: AdminCompaniesComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/companies/company/company-details/:id',
    component: AdminCompanyDetailsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/add-company',
    component: AdminAddCompanyComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/edit-company/:id',
    component: AdminAddCompanyComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/company-billing/:id',
    component: AdminCompanyBillingComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/company-pricing/:id',
    component: AdminCompanyPricingComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/params',
    component: AdminParamsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/params/single-param/:id',
    component: AdminSingleParamComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/users',
    component: AdminUsersComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/openings',
    component: AdminOpeningsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/user-details/:id',
    component: AdminUserDetailsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/translations',
    component: AdminTranslationsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/consumerProducts',
    component: AdminConsumerProductsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/validateCompany',
    component: AdminValidateCompanyComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/articles',
    component: AdminArticlesComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/jobtitles',
    component: AdminJobtitlesComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/skills',
    component: AdminSkillsComponent,
    canActivate: [AdminGuard]
  },
  {
    path: 'admins/admin/schools',
    component: AdminSchoolsComponent,
    canActivate: [AdminGuard]
  },


  {
    path: '',
    pathMatch: 'prefix',
    redirectTo: '/login'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
  
 }
